import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RxEmitter } from 'common/rxjs/rx-emitter';
import { Editor } from 'tinymce';
import { broadcastEvents } from 'common/common/constants/broadcast-events';
import { first } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GenesysTinyMCEPluginsService {
  constructor(private _translateService: TranslateService, private _rxEmitter: RxEmitter) {}

  setFileUploadButtonDisabled(editor: Editor, isDisabled: boolean) {
    editor.fire('setFileUploadButtonDisabled', { isDisabled });
  }

  addDynamicFileUploadButton(editor: Editor, showFileUpload: boolean): void {
    this._translateService.get('genesysEditor.imageUploadButtonTooltip').pipe(first()).subscribe(tooltipText => {
      editor.ui.registry.addButton('fileUpload', {
        icon: 'upload',
        tooltip: tooltipText,
        onAction: () => {
          this._rxEmitter.send(broadcastEvents.fileUploadOpened, null);
        },
        onSetup: (buttonApi) => {
          editor.on('setFileUploadButtonDisabled', (event) => {
            buttonApi.setDisabled(event.isDisabled);
          });

          buttonApi.setDisabled(!showFileUpload);

          return () => {
            editor.off('setFileUploadButtonDisabled');
          };
        }
      });
    });
  }

  addInsertImagePlugin(editor: Editor): void {
    const namespace = `${broadcastEvents.fileUploadOpened}${editor.id}`;
    this._translateService.get('bcEditor.toolbar.imageInsertLink').pipe(first()).subscribe(tooltipText => {
      editor.ui.registry.addButton('insertImage', {
        icon: 'image',
        tooltip: tooltipText,
        onAction: () => {
          this._rxEmitter.send(namespace, null);
        }
      });
    });
  }
}
